
import { HttpCostPredictionList,HttpDeleteCostPrediction} from '@/service/logistics';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';

export default {
    mixins: [TableList, mixin],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            addressCodeList:[],
            formData: {
                search: {
                    EQ_type: "local_port"
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            title:"",
            entitle:"",
            Plugins: { show: true },
        };
    },
    created() {
      },
    methods: {
        ajaxRequest: HttpCostPredictionList,
        interceptRequest(params) {
            if(!params.search.EQ_type){
                params.search.EQ_type = "local_port"
                this.$set(this.formData.search,"EQ_type","local_port");
            }
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
                if(this.isLocal){
                    this.entitle = 'fbb.logistics.cost_local_add'
                    this.title = "添加本地港口费用"
                }else if(this.isOcean){
                    this.entitle = 'fbb.logistics.cost_ocean_add'
                    this.title = "添加海运费"
                }else if(this.isDischargeHandle){
                    this.entitle = 'fbb.logistics.cost_handle_add'
                    this.title = "添加卸货港处理费用"
                }else if(this.isTruck){
                    this.entitle = 'fbb.logistics.cost_truck_add'
                    this.title = "添加集卡运费"
                }else if(this.isDischarge){
                    this.entitle = 'fbb.logistics.cost_discharge_add'
                    this.title = "添加卸货费"
                }else if(this.isPallet){
                    this.entitle = 'fbb.logistics.cost_pallet_add'
                    this.title = "添加打托和贴标费"
                }else if(this.isAmazonTruck){
                    this.entitle = 'fbb.logistics.cost_amazon_add'
                    this.title = "添加亚马逊卡车运费"
                }else if(this.isOther){
                    this.entitle = 'fbb.logistics.cost_other_add'
                    this.title = "添加其他费用"
                }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t( this.entitle, { defaultValue: this.title }),
                        show:true,
                        width:500,
                        component: "comIndex",
                        costType:this.formData.search.EQ_type,
                        type:'add',
                        showFooter:false,
                    }
                    break;              
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:500,
                        component: "comIndex",
                        activeid:params,
                        costType:this.formData.search.EQ_type,
                        type:'edit',
                        showFooter:false,
                    }
                    break;
                case 'delete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDeleteCostPrediction
                    };
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/costPrediction/batchImport",
                        name: "multipartFile",
                        component: "compUpload",
                        data: {
                            type:this.formData.search.EQ_type,
                                contextId: global.SYSID 
                            },
                        download: () => {
                            let template;
                            if(this.formData.search.EQ_type === 'local_port'){
                                template = "/static/template/logistics_cost_local.xls"
                            }else if(this.formData.search.EQ_type === 'ocean'){
                                template = "/static/template/logistics_cost_ocean.xls"
                            }else if(this.formData.search.EQ_type === 'discharge_handle'){
                                template = "/static/template/logistics_cost_handle.xls"
                            }else if(this.formData.search.EQ_type === 'truck'){
                                template = "/static/template/logistics_cost_truck.xls"
                            }else if(this.formData.search.EQ_type === 'discharge'){
                                template = "/static/template/logistics_cost_discharge.xls"
                            }else if(this.formData.search.EQ_type === 'pallet'){
                                template = "/static/template/logistics_cost_pallet.xls"
                            }else if(this.formData.search.EQ_type === 'amazon_truck'){
                                template = "/static/template/logistics_cost_amazon.xls"
                            }else if(this.formData.search.EQ_type === 'other'){
                                template = "/static/template/logistics_cost_other.xls"
                            }
                            this.handleWebfs(template, {}, {
                                executor: 'download',
                                type: 'url'
                            });
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show:true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete', { defaultValue: '删除' }),
                show:true,
                params: id,
                operate: 'delete'
            }
          ]
        },
        
    },
    computed: {
        ...mapGetters('dictionary', ['getSystemPortList',"getCompanyList","getFBBFilterDisabledAllWarehouse"]),
        isLocal() {
			return this.formData.search.EQ_type === 'local_port'
		},
        isOcean() {
			return this.formData.search.EQ_type === 'ocean'
		},
        isDischargeHandle() {
			return this.formData.search.EQ_type === 'discharge_handle'
		},
        isTruck() {
			return this.formData.search.EQ_type === 'truck'
		},
        isDischarge() {
			return this.formData.search.EQ_type === 'discharge'
        },
        isPallet() {
			return this.formData.search.EQ_type === 'pallet'
        }, 
        isAmazonTruck() {
			return this.formData.search.EQ_type === 'amazon_truck'
        },
        isOther() {
			return this.formData.search.EQ_type === 'other'
		},
        TabsData() {
            return [
                {
                    name: this.$t('fbb.logistics.cost_local', { defaultValue: "本地港口费用" }),
                    key: 'EQ_type',
                    val: "local_port",
                },
                {
                    name: this.$t('fbb.headlogistics.cost_sea', { defaultValue: "海运费" }),
                    key: 'EQ_type',
                    val: "ocean",
                },
                {
                    name: this.$t('fbb.logistics.cost_handle', { defaultValue: "卸货港处理费用" }),
                    key: "EQ_type",
                    val: "discharge_handle",
                },
                {
                    name: this.$t('fbb.logistics.cost_truck', { defaultValue: "集卡运费" }),
                    key: "EQ_type",
                    val: "truck",
                },{
                    name: this.$t('fbb.logistics.cost_discharge', { defaultValue: "卸货费" }),
                    key: "EQ_type",
                    val: "discharge",
                },{
                    name: this.$t('fbb.logistics.cost_pallet', { defaultValue: "打托和贴标费" }),
                    key: "EQ_type",
                    val: "pallet",
                },{
                    name: this.$t('fbb.logistics.cost_amazon_truck', { defaultValue: "亚马逊卡车运费" }),
                    key: "EQ_type",
                    val: "amazon_truck",
                },{
                    name: this.$t('fbb.logistics.cost_other', { defaultValue: "其他费用" }),
                    key: "EQ_type",
                    val: "other",
                }
            ]
        },
        ToolsData() {
            
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
            }, {
                name: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                operate: "upload",
            }]
        },
        SearchsData() {
            return [{
                    label: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' }),
                    key: 'EQ_carrierId',
                    tag: 'vSelect',
                    width:150,
                    show: true,
                    options: this.getCompanyList,
                    props: {
                        filterable: true,
                    },
                }
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司	' }),
                    key: 'carrier',
                }, {
                    title: this.$t('fbb.logistics.cost_port', { defaultValue: '港口' }),
                    width:this.isLocal? 150 : 0,
                    key: 'shipPort',
                },{
                    title: this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' }),
                    width:this.isOcean? 150 : 0,
                    key: 'shipPort',
                },{
                    title: this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' }),
                    width:this.isOcean? 150 : 0,
                    key: 'purposePort',
                },{
                    title: this.$t('fbb.logistics.cost_discharge_port', { defaultValue: '卸货港' }),
                    width:this.isDischargeHandle||this.isTruck? 150 : 0,
                    key: 'purposePort',
                },{
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    width:this.isTruck||this.isDischarge||this.isPallet? 150 : 0,
                    key: 'purposeDepot',
                },{
                    title: this.$t('fbb.warehouse.transit_warehouse', { defaultValue: '中转仓' }),
                    width:this.isAmazonTruck? 150 : 0,
                    key: 'purposeDepot',
                }, {
                    title: this.$t('fbb.logistics.cost_amazonfc', { defaultValue: 'Amazon FC' }),
                    width:this.isAmazonTruck? 150 : 0,
                    key: 'amazonFc',
                },  {
                    title: this.$t('fbb.logistics.cost_cabinet', { defaultValue: '柜型' }),
                    width:this.isLocal||this.isOcean||this.isTruck||this.isDischarge? 150 : 0,
                    key: 'cabinetType',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getCabinetType, row.cabinetType)
                },{
                    title: this.$t('fbb.logistics.cost_subtype', { defaultValue: '其他费用类型' }),
                    width:this.isOther? 150 : 0,
                    key: 'subType',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getCostType, row.subType)
                }, {
                    title: this.$t('fbb.logistics.cost_port_fee', { defaultValue: '港口费(USD)' }),
                    width:this.isLocal? 150 : 0,
                    key: 'cost',
                }, {
                    title: this.$t('fbb.logistics.cost_ocean_fee', { defaultValue: '海运费(USD)' }),
                    width:this.isOcean? 150 : 0,
                    key: 'cost',
                }, {
                    title: this.$t('fbb.logistics.cost_handle_fee', { defaultValue: '处理费(USD)' }),
                    width:this.isDischargeHandle? 150 : 0,
                    key: 'cost',
                },{
                    title: this.$t('fbb.logistics.cost_truck_fee', { defaultValue: '运费(USD)' }),
                    width:this.isTruck? 150 : 0,
                    key: 'cost',
                },{
                    title: this.$t('fbb.logistics.cost_discharge_fee', { defaultValue: '卸货费(USD)' }),
                    width:this.isDischarge? 150 : 0,
                    key: 'cost',
                },{
                    title: this.$t('fbb.logistics.cost_fee', { defaultValue: '费用(USD)' }),
                    width:this.isPallet||this.isOther? 150 : 0,
                    key: 'cost',
                },{
                    title: this.$t('fbb.logistics.cost_amazon_fee', { defaultValue: '卡车运费(USD)' }),
                    width:this.isAmazonTruck? 150 : 0,
                    key: 'cost',
                },{
                    title: this.$t('fbb.logistics.cost_unit', { defaultValue: '单位' }),
                    width:this.isDischarge||this.isAmazonTruck? 150 : 0,
                    key: 'unit',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getUnit, row.unit)
                }, {
                    title: this.$t('fbb.logistics.cost_date_start', { defaultValue: '有效期开始时间' }),
                    width: 150 ,
                    key: 'effectiveDateStart',
                    sortable:true,
                }, {
                    title: this.$t('fbb.logistics.cost_date_end', { defaultValue: '有效期截止时间' }),
                    width: 150 ,
                    key: 'effectiveDateEnd',
                    sortable:true,
                }];
        },
    },
};




